/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    FileTransferDto,
    OrgImageDto,
    OrganizationDto,
    PageOrganizationDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class OrganizationControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        addOrgImage(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
                    , 
                    
                    requestBody: OrgImageDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}/image`;

            return this._httpClient.post<string>(url, requestBody, requestOptions);
    }


        approveOrganization(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}/approve`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        createOrganization(
                    
                    
                    requestBody: OrganizationDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/organization`;

            return this._httpClient.post<string>(url, requestBody, requestOptions);
    }


        deleteOrganizationLogo(
                    id: string
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}/logo`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        getAllOrganizations(
                
                queryParams: {
                    ids?: Array<string>,
                    name?: string,
                    userLegalEntityId?: number,
                    owner?: number
                }
    ): Observable<Array<OrganizationDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/all`;

            return this._httpClient.get<Array<OrganizationDto>>(url, requestOptions);
    }


        getOrgUnitImage1(
                    id: number,
                    imageId: number
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}/image/${imageId}`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        getOrganization(
                    id: string
    ): Observable<OrganizationDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}`;

            return this._httpClient.get<OrganizationDto>(url, requestOptions);
    }


        getOrganizationLogo(
                    id: string,
                    logoUri: string
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}/logo/${logoUri}`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        getOrganizationsByApprovalStatus1(
                    status: string
                , 
                queryParams: {
                    ids?: Array<string>,
                    name?: string,
                    userLegalEntityId?: number
                }
    ): Observable<Array<OrganizationDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/all/${status}`;

            return this._httpClient.get<Array<OrganizationDto>>(url, requestOptions);
    }


        rejectOrganization(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}/reject`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        removeOrgImage(
                    id: number,
                    imageId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}/image/${imageId}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        removeOrganization(
                    id: string
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        searchPage(
                
                queryParams: {
                    ids?: Array<string>,
                    name?: string,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageOrganizationDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/page`;

            return this._httpClient.get<PageOrganizationDto>(url, requestOptions);
    }


        searchSingleOrganization(
                
                queryParams: {
                    wineryId?: number
                }
    ): Observable<OrganizationDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/organization/single`;

            return this._httpClient.get<OrganizationDto>(url, requestOptions);
    }


        updateOrganization(
                    
                    
                    requestBody: OrganizationDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/organization`;

            return this._httpClient.put<boolean>(url, requestBody, requestOptions);
    }


        updateOrganizationLogo(
                    id: string
                    , 
                    
                    requestBody: FileTransferDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/organization/${id}/logo`;

            return this._httpClient.put<number>(url, requestBody, requestOptions);
    }


}

